import { ThemeContext } from '@tracsis/library/src/context/ThemeContext';
import cx from 'classnames';
import React, { useContext } from 'react';
import {
	Accordion,
	AccordionItem,
	AccordionItemButton,
	AccordionItemHeading,
	AccordionItemPanel,
} from 'react-accessible-accordion';

import { SVGWrapper } from '../../index';
import { Chevron } from '../Icon';
import * as styles from './AccordionPanel.module.css';

const AccordionPanel = ({
	heading,
	children,
	as: Component = 'div',
	className = '',
}: {
	heading?: string;
	children: React.ReactNode;
	as?: React.ElementType;
	className?: string;
}) => {
	return (
		<Component className={cx(styles.panel, className)}>
			{heading && <h3 className={styles.headline}>{heading}</h3>}

			<Accordion allowMultipleExpanded allowZeroExpanded>
				{children}
			</Accordion>
		</Component>
	);
};

const Header = ({ children }: { children: React.ReactNode }) => {
	return <div className={styles.intro}>{children}</div>;
};

const Item = ({
	label,
	children,
}: {
	label: string;
	children: React.ReactNode;
}) => {
	const { variant } = useContext(ThemeContext);
	return (
		<AccordionItem className={styles.item}>
			<AccordionItemHeading className={styles.heading}>
				<AccordionItemButton className={cx(styles.button, styles[variant])}>
					{label}
					<SVGWrapper height="1rem" width="1rem">
						<Chevron />
					</SVGWrapper>
				</AccordionItemButton>
			</AccordionItemHeading>
			<AccordionItemPanel className={styles.itemPanel}>
				{children}
			</AccordionItemPanel>
		</AccordionItem>
	);
};

AccordionPanel.Header = Header;
AccordionPanel.Item = Item;

export default AccordionPanel;
